import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useFeatures, useSession } from '@cordata/buffet';

import { Accordian, PageLayout } from '~/components';
import usePatient from '~/utils/patient/hook';
import { useQueryParam } from '~/utils';
import { hasFullPatientIdentityAccess } from '~/utils/patient/identity-access';

import Custody from './custody';
import Placement from './placement';
import Case from './case';
import Maltreatment from './maltreatment';

const ChildrensServices = () => {
  const [, patient, actions] = usePatient();
  const [openPanel, setOpenPanel] = useQueryParam('expand');
  const { hasIdentityViewFull } = useFeatures();
  const { current } = useSession();

  useEffect(() => {
    actions.audit('ChildServices');
  }, []);

  if (!hasFullPatientIdentityAccess(patient, current?.attributes?.accessibleDivisions)) {
    return <Redirect to={`/patients/${patient.id}`} />;
  }

  return (
    <PageLayout title="Children's Services">
      <Accordian
        openPanel={openPanel}
        setOpenPanel={setOpenPanel}
        items={[{
          title: 'Custody',
          body: <Custody />,
        }, {
          title: 'Placement',
          body: <Placement />,
        }, {
          title: 'Case',
          body: <Case />,
          visible: hasIdentityViewFull,
        }, {
          title: 'Maltreatment',
          body: <Maltreatment />,
          visible: hasIdentityViewFull,
        }]}
      />
    </PageLayout>
  );
};

export default ChildrensServices;
